import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'shared/assets/icons';
import { Button, Sizes as ButtonSizes } from 'shared/components/ui/button';
import { IconButton, Sizes } from 'shared/components/ui/icon-button';

import * as Styled from './dialog-header.style';

export type FormDialogHeaderProps = {
  onCancel: () => void;
  title: string;
  subtitle?: string;
  canSubmit?: boolean;
  className?: string; // Allow styling overrides
};

export const FormDialogHeader: React.FC<FormDialogHeaderProps> = ({
  title,
  subtitle,
  onCancel,
  canSubmit,
  className,
}) => {
  const { t } = useTranslation();

  const _onCancel = (e: React.MouseEvent) => {
    e.preventDefault();
    onCancel();
  };

  return (
    <Styled.Container className={className}>
      <Styled.Content>
        <Styled.MobileButtonContainer>
          <IconButton
            icon={X}
            size={Sizes.Large}
            onClick={_onCancel}
            type="button"
          />
        </Styled.MobileButtonContainer>
        <Styled.TitleContainer>
          <Typography variant="h5" component="h1">
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="textSecondary">
              {subtitle}
            </Typography>
          )}
        </Styled.TitleContainer>
      </Styled.Content>

      <Styled.MobileButtonContainer>
        <Button size={ButtonSizes.Medium} type="submit" disabled={!canSubmit}>
          {t('general.labels.save')}
        </Button>
      </Styled.MobileButtonContainer>
    </Styled.Container>
  );
};
